const state = {
  visible: false
}

const actions = {
  open ({ commit }) {
    commit('open')
  },

  close ({ commit }) {
    commit('close')
  }
}

const mutations = {
  open ({ commit }) {
    state.visible = true
  },

  close ({ commit }) {
    state.visible = false
  }
}

const globalLoader = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default globalLoader
